<script>
  let { 
    /** @type {SvelteSnippet} */
    children, 
    class: css_class,
    ...rest
  } = $props();
</script>

{#if children}
  <span class='tag text-emphasis text-control leading-trim size-reduce-1 {css_class}' {...rest}>{@render children()}</span>
{/if}
  
<style lang="postcss">
  .tag {
    white-space: nowrap;
    user-select: none;
    padding-inline: var(--size-2);
    position: relative;
    z-index: 1;
    &:before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      border: 1px solid var(--color-default-stroke);
      pointer-events: none;
      padding-block: var(--size-1);
      border-radius: var(--size-2);
      background: var(--color-default-emphasis-background);
      z-index: -1;
      height: calc(100% + var(--size-3));
      top: calc(var(--size-3) * -0.5);
    }
  }
</style> 